module.exports = "<div id=\"search-map\" ></div>"